import React from 'react';
import { Spinner, ErrorBox, EmptyState } from './UI';
import { useCompetitions } from '../hooks/useApi';

export default function CompetitionSelector({ onSelect }) {
  const { competitions, loading, error } = useCompetitions();

  if (loading) return <Spinner label="Caricamento competizioni…" />;
  if (error) return <ErrorBox message={`Impossibile caricare le competizioni: ${error}`} />;
  if (!competitions.length) return <EmptyState icon="🏆" title="Nessuna competizione disponibile" />;

  return (
    <section className="selector-section">
      <h2 className="section-title">Seleziona Competizione</h2>
      <div className="card-grid">
        {competitions.map(comp => (
          <button
            key={comp.competitionId}
            className="comp-card"
            onClick={() => onSelect(comp)}
          >
            <span className="comp-badge">🏆</span>
            <span className="comp-name">{comp.officialName || comp.name}</span>
            {comp.acronymName && (
              <span className="comp-acronym">{comp.acronymName}</span>
            )}
          </button>
        ))}
      </div>
    </section>
  );
}
